<!--
按钮组件：
<sl-btn text="Download data" icon="sl-download"></sl-btn>
<sl-btn text="Refund" icon="sl-refund"></sl-btn>
<sl-btn text="Pending refunds" icon="sl-pending_refund"></sl-btn>
<sl-btn class="sl-btn-blue" text="Publish" icon="sl-publish"></sl-btn>
<sl-btn class="sl-btn-lightblue" text="Confirm"></sl-btn>
<sl-btn class="sl-btn-lightblue" text="Back"></sl-btn>
<sl-btn class="sl-btn-lightblue" text="Cancel"></sl-btn>
<sl-btn class="sl-btn-lightblue" text="Save"></sl-btn>
<sl-btn class="sl-btn-lightred" text="Delete"></sl-btn>
<sl-btn class="sl-btn-green" text="Create New Coupon" icon="sl-add" :loading="btnLoading"></sl-btn>
-->

<template>
  <div class="sl-box">
      <div class="revenu" :class="classObject">
        <div class="sl-cnt">
          <span>{{ value }}</span>
        </div>
        <div class="sl-title"> {{ title }} </div>
      </div>

  </div>
</template>

<script>
export default {
  name: 'sl-box',
  props: {
    title: {
      type: String,
      default: ''
    },
    cnt: {
      // type: String,
      default: ''
    },
    index: {
      // type: String,
      default: 0
    }
  },
  computed: {
    value() {
      const cnt = this.cnt.toString()
      return cnt
    },
    classObject: function () {
      return {
        aclass: this.index === 0,
        bclass: this.index === 1,
        cclass: this.index === 2,
        dclass: this.index === 3,
        eclass: this.index === 4,
        fclass: this.index === 5,
        gclass: this.index === 6
      }
    }
  }
}
</script>
<style scoped>
.sl-box {
  flex: 1;
}

.sl-box:hover {
  /* background-color: #011935; */
}

.sl-title {
  font-family: MicrosoftYaHei;
  color: #20a0ff;
  font-size: 14px;
  font-weight: 500;
}

.sl-cnt i {
  font-size: 16px;
  color: #fff;
}

.sl-cnt span {
  font-family: MicrosoftYaHei;
  color: #20a0ff;
  font-size: 20px;
  font-weight: 500;
}

@media screen and (max-width: 1200px) {
  .sl-box {
    flex: 1 1 calc((100% - 16px * 2) / 3);
  }
  .sl-title {
    font-size: 13px;
  }
}

@media screen and (max-width: 768px) {
  .sl-box {
    flex: 1 1 calc((100% - 16px * 1) / 2);
  }
  .sl-title {
    font-size: 12px;
  }
}

.revenu {
  height: 110px;
  background: #FFFFFF;
  box-shadow: 0px 3px 4px 0px rgba(230, 230, 230, 0.5);
  /* border: 1px solid #2B52BB; */
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  /* margin: 8px; */
}

.sl-box:nth-of-type(1) .revenu {
  margin-left: 0;
}
.sl-box:last-of-type(6) .revenu {
  margin-right: 0;
}

.aclass{
  /* border: 1px solid #EB6100; */
  /* background: linear-gradient(180deg, #f2f9fe, #e6f4fe); */
  background: linear-gradient(180deg,#f5fef2,#e6feee);
}

.bclass{
  /* border: 1px solid #D47AFF; */
  background: linear-gradient(180deg,#f5fef2,#e6feee);
}

.cclass{
  /* border: 1px solid #27E5F6; */
  background: linear-gradient(180deg, #f2f9fe, #e6f4fe);
}

.dclass{
  /* border: 1px solid #23a6a6; */
  background: linear-gradient(180deg,#f7f7ff,#ececff);
}

.eclass{
  /* border: 1px solid #240b6a; */
  background: linear-gradient(180deg,#f7f7ff,#ececff);
}

.fclass{
  /* border: 1px solid #770f45; */
  background: linear-gradient(to top, #beedfe, #ecf8fc);
}

.gclass{
  border: 1px solid #900b0b;
}
</style>



// WEBPACK FOOTER //
// sl-box.vue?57f41e1f